export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/sync.worker.de7ce2e8.worker.js");
}
